import { Box, Button, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import ResponsiveModal from '@/components/basic/ResponsiveModal'
import { OneLinkQrCode } from '@/components/OneLinkQrCode'

interface DownloadAppModalProps {
  visible: boolean
  onClose: () => void
}

export default function DownloadAppModal({ visible, onClose }: DownloadAppModalProps) {
  const t = useTranslations('downloadAppModal')

  return (
    <ResponsiveModal
      title={
        <Text m={'auto'} variant={'heading2'} ta="center">
          {t('title')}
        </Text>
      }
      opened={visible}
      onClose={onClose}
      classNames={{
        title: 'w-full ',
      }}
    >
      <Box>
        <Stack>
          <Text
            mb={32}
            mx={'auto'}
            ta="center"
            variant={'body'}
            c="var(--content-secondary)"
            fz={'14px'}
          >
            {t('description')}
          </Text>
          <Box mx={'auto'} w={164} h={164} p={10.25} bdrs={12} style={{ background: '#FFF' }}>
            <OneLinkQrCode size="100%" />
          </Box>
          <Button onClick={onClose} radius={'md'}>
            {t('cta_text')}
          </Button>
        </Stack>
      </Box>
    </ResponsiveModal>
  )
}
